// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2023-03-23 21:41:46 +0100 (Thu, 23 Mar 2023) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 133238 $
// Purpose     : timeline components
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {usePhysicalNode} from 'uix/hooks'

// ---Local imports
import {BasicTimeline} from './components'

// ---Exports
const DEFAULT_DAYS = 3
const ETYPES = {
  domain: [
    'Import',
    'ReleaseStateChange',
    'WikiChange',
    'DomainConfigChanged',
    'CodeChange',
    'Job',
    'RunningJob',
  ],
  presentation: ['PresentationSlideChange', 'ResourceUpload'],
  pseudo_wiki: ['WikiChange', 'ResourceUpload'],
  deliverer: [
    'PublisherData',
    'DistributorData',
    'InsertMetadataPublisher',
    'DelivererChange',
    'DistributorChange',
  ],
  code: ['CodeChange'],
  webresource: ['ResourceUpload'],
}

const TimelinePanel = ({header, days, eventTypes, eventFilter, eventValueFilter, i18n}) => {
  let node = usePhysicalNode()
  let datatypeName = node.datatypeName
  if (datatypeName == 'container') {
    if (node.subtype == 21) {
      datatypeName = 'presentation'
    } else if (node.subtype == 1) {
      datatypeName = 'pseudo_wiki'
    } else if (node.subtype == 2) {
      datatypeName = 'webresource'
    } else if (node.subtype == 14) {
      datatypeName = 'deliverer'
    } else if (node.subtype == 18) {
      datatypeName = 'code'
    }
  }

  if (!eventTypes) {
    eventTypes = ETYPES[datatypeName]
  }
  return (
    <BasicTimeline
      otid={datatypeName !== 'domain' ? node.otid : undefined}
      days={days || DEFAULT_DAYS}
      eventType={eventTypes}
      eventValueFilter={eventValueFilter}
      grouped
      i18n={i18n}
      eventFilter={eventFilter}
      header={header}
    />
  )
}

export const NodeTimeline = {
  Comp: TimelinePanel,
  order: 99,
  datatypes: ['domain', 'presentation', 'container'],
}
